import React from 'react';

import LockRoundedIcon from '@material-ui/icons/LockRounded';
import PublicIcon from '@material-ui/icons/Public';
import { TeamIconContainer } from 'styles/common';

import { TEAM_VISIBILITY } from 'constants/ProjectConstants';

const TeamVisibilityIcon = ({ show = false, visibilityType }) => (
  <>
    {show && visibilityType && (
      <TeamIconContainer>
        {visibilityType === TEAM_VISIBILITY.global ? <PublicIcon /> : <LockRoundedIcon />}
      </TeamIconContainer>
    )}
  </>
);

export default TeamVisibilityIcon;
